import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import EmptyFile from "../Common/Empty/EmptyFile";
import HeadTitle from "../Common/HeadTitle/HeadTitle";
import { Sdata } from "../components/Destinations/Sdata";
import "./singlepage.css";

const SinglePage = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    let item = Sdata.find((item) => item.id === parseInt(id));
    if (item) {
      setItem(item);
      window.scrollTo(0, 0);
    }
  }, [id]);

  return (
    <>
      <HeadTitle />

      {item ? (
        <section className="single-page top">
          <div className="container">
            <article className="content flex">
              <div className="main-content">
                <img src={item.image} alt="myimgs" />
                <p>{item?.sidepara}</p>

                <h1>{item.title}</h1>
                <div className="para flex_space">
                  {/* Use t function to translate the description */}
                  <p>{t(item.descKey)}</p>
                </div>

                <div className="image grid1 ">
                  <img src={item.paraImage_one} alt="" />
                  <img src={item.paraImage_two} alt="" />
                </div>
              </div>
              <div className="side-content">
                <div className="box">
                  <h2>{t("help")}</h2>
                  <button className="outline-btn">
                    <i className="fa fa-phone-alt"></i>
                    {t("contact")}
                  </button>
                </div>

                <div className="box2">
                  {/* Additional content */}
                </div>
              </div>
            </article>
          </div>
        </section>
      ) : (
        <EmptyFile />
      )}
    </>
  );
};

export default SinglePage;
